import createIcon from '../../createIcon';

/**
 * @component @name LastPage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS43OTQ5MiA3LjQxTDEwLjM4NDkgMTJMNS43OTQ5MiAxNi41OUw3LjIwNDkyIDE4TDEzLjIwNDkgMTJMNy4yMDQ5MiA2TDUuNzk0OTIgNy40MVpNMTYuMjA0OSA2SDE4LjIwNDlWMThIMTYuMjA0OVY2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LastPage = createIcon('LastPage', [
  [
    'path',
    {
      d: 'M5.79492 7.41L10.3849 12L5.79492 16.59L7.20492 18L13.2049 12L7.20492 6L5.79492 7.41ZM16.2049 6H18.2049V18H16.2049V6Z',
      key: 'kiw08v',
    },
  ],
]);

export default LastPage;
